import styled from 'styled-components';
import { ColorsTypes } from 'styled-components';
import { space } from 'styled-system';

interface BreakpointsObject {
  m?: number | string;
  t?: number | string;
  d?: number | string;
}

interface HrProps extends React.HTMLAttributes<HTMLHRElement> {
  color?: ColorsTypes;
  size?: string;
  m?: number | BreakpointsObject | string;
  mt?: number | BreakpointsObject | string;
  mr?: number | BreakpointsObject | string;
  mb?: number | BreakpointsObject | string;
  ml?: number | BreakpointsObject | string;
  mx?: number | BreakpointsObject | string;
  my?: number | BreakpointsObject | string;
}

const Hr = styled('hr')<HrProps>`
  border: 0;
  background: transparent;
  border-top: ${({ size }) => size || '1px'} solid ${({ theme, color }) => theme.colors[color || 'gray_200']};
  width: 100%;
  ${space}
`;

export default Hr;
